import { ReactNode } from "react"
import cn from "../../../../utils/classes"

interface TableGridProps extends React.TdHTMLAttributes<HTMLTableCellElement> {
  id: string
  children: ReactNode
}

export const TableCell: React.FC<TableGridProps> = ({
  id,
  children,
  ...props
}) => {
  const className = cn(
    "break-words align-left border-solid border-0 !border-b-[1px] border-gray-200 !px-[16px] !py-[18px] min-w-[117px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#2198CC] focus-visible:rounded-lg",
    props.className,
  )
  return (
    <td id={id} {...props} className={className}>
      {children}
    </td>
  )
}
